<template>
  <modal 
    :show.sync="show"
    modal-classes="modal-dialog-centered modal-login"
    @close="close">
    <div 
      slot="base-content" 
      class="card card-plain card-login mb-0">
      <div class="modal-header justify-content-center">
        <button 
          type="button" 
          class="btn-sm close text-dark" 
          data-dismiss="modal" 
          aria-hidden="true"
          @click="close">
          <i class="now-ui-icons ui-1_simple-remove"/>
        </button>
        <div class="header header-primary text-center">
          <h4 class="font-weight-bold m-0">Credit Card</h4>
        </div>
      </div>
      <div class="modal-body py-0">
        <div class="card-body">
          <label>Card Number</label>
          <fg-input
            v-cardformat:formatCardNumber
            ref="cardNumInput"
            :value="cardNumber"
            :error="errCardNumber"
            :autocomplete="'cc-number'"
            placeholder="#### #### #### ####"
            @input="cardNumber=$event.target.value"
            @blur="validateCardNumber">
            <div 
              slot="addonLeft" 
              class="card-icon-wrapper">
              <img 
                :src="'img/card-icons/' + getIcon() + '.svg'"
                height="18">
            </div>
          </fg-input>
          <div class="row">
            <div class="col-6">
              <label>Expiration</label>
              <fg-input
                v-cardformat:formatCardExpiry
                ref="cardExpInput"
                :value="cardExpiry"
                :error="errCardExpiry"
                :autocomplete="'cc-exp'"
                placeholder="Expiration"
                @input="cardExpiry=$event.target.value"
                @blur="validateCardExpiry"/>
            </div>
            <div class="col-6">
              <label>CVC</label>
              <fg-input
                v-cardformat:formatCardCVC
                ref="cardCvcInput"
                :value="cardCvc"
                :error="errCardCvc"
                :autocomplete="'cc-csc'"
                placeholder="CVC"
                @input="cardCvc=$event.target.value"
                @blur="validateCardCVC"/>
            </div>
          </div>
          <n-checkbox v-model="save">Save to file?</n-checkbox>
        </div>
      </div>
      <div class="modal-footer">
        <n-button
          :disabled="loading" 
          native-type="submit"
          type="success" 
          round 
          class="w-100"
          @click.native="saveCard">
          {{ loading ? '' : 'Save' }}
          <i 
            v-if="loading" 
            class="bx bx-loader bx-spin"/>
        </n-button>
      </div>
    </div>
  </modal>
</template>
<script>
  import axios from 'axios';
  import { mapState, mapMutations } from 'vuex';
  import { Notification } from 'element-ui';
  import { Button, Checkbox, FormGroupInput, Modal } from '@/components';

  export default {
    components: {
      [Button.name]: Button,
      [Checkbox.name]: Checkbox,
      [FormGroupInput.name]: FormGroupInput,
      Modal
    },
    props: {
      open: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        show: false,
        apiLoginID: '',
        clientKey: '',
        cardBrand: '',
        cardNumber: '',
        errCardNumber: '',
        cardExpiry: '',
        errCardExpiry: '',
        cardCvc: '',
        errCardCvc: '',
        save: false,
        $cardFormat: function() {},
        loading: false,
        status: -1
      };
    },
    watch: {
      open() {
        this.show = this.open;
        setTimeout(() => {
          this.$refs.cardNumInput.$el.querySelector('input').focus();
        }, 0);
      },
      cardNumber(val) {
        if (this.$cardFormat.validateCardNumber(val)) {
          this.$refs.cardExpInput.$el.querySelector('input').focus();
          this.errCardNumber = '';
        } else {
          this.errCardNumber = 'Card number is not valid.';
        }
      },
      cardExpiry(val) {
        if (this.$cardFormat.validateCardExpiry(val)) {
          this.$refs.cardCvcInput.$el.querySelector('input').focus();
          this.errCardExpiry = '';
        } else {
          this.errCardExpiry = 'Expiration is not valid.';
        }
      },
      cardCvc(val) {
        if (this.$cardFormat.validateCardCVC(val)) {
          this.errCardCvc = '';
        } else {
          this.errCardCvc = 'CVC is not valid.';
        }
      }
    },
    created() {
      axios.get('paymentgateway').then(res => {
        const { data } = res;
        console.log('paymentgateway: ', data);
        this.apiLoginID = data.authId;
        this.clientKey = data.publicKey;
      });
    },
    methods: {
      close() {
        this.status = -1;
        this.cardNumber = '';
        this.cardExpiry = '';
        this.cardCvc = '';
        this.$emit('close');
        setTimeout(() => {
          this.cardBrand = '';
          this.errCardNumber = '';
          this.errCardExpiry = '';
          this.errCardCvc = '';          
        }, 0);
      },
      getIcon() {
        return this.cardBrand === 'unknown' || this.cardBrand === '' ? 'default' : this.cardBrand;
      },
      saveCard() {
        let flag = true;
        if (!this.cardNumber) {
          this.errCardNumber = 'Card number is required';
          flag = false;
        }
        if (!this.cardExpiry) {
          this.errCardExpiry = 'Expiration is required';
          flag = false;
        }
        if (!this.cardCvc) {
          this.errCardCvc = 'CVC is required';
          flag = false;
        }

        if (flag) {
          this.loading = true;
          const month = this.cardExpiry.split('/')[0].trim();
          const year = this.cardExpiry.split('/')[1].trim();
          Accept.dispatchData({
            authData: {
              apiLoginID: this.apiLoginID,
              clientKey: this.clientKey
            },
            cardData: {
              cardNumber: this.cardNumber.replaceAll(' ', ''),
              month,
              year: year.length === 2 ? year : year.substr(2, 2),
              cardCode: this.cardCvc
            }
          }, res => {
            console.log('accept js: ', res);
            if (res.messages.resultCode === 'Ok') {
              this.$emit('save', {
                token: res.opaqueData.dataValue,
                tokenDescription: res.opaqueData.dataDescriptor,
                cardsOnFile: {
                  cardType: this.cardBrand,
                  lastFour: 'xxxx' + this.cardNumber.replaceAll(' ', '').substr(12),
                  expirationDate: this.cardExpiry
                },
                save: this.save
              });
              this.loading = false;
              this.close();
            } else {
              this.loading = false;
              Notification.error({
                title: 'Error',
                message: res.messages.message[0].text,
                customClass: 'alert-danger',
                offset: 80,
                showClose: false,
              });
            }
          });
        }
      },
      validateCardNumber() {
        if (!this.cardNumber) {
          this.errCardNumber = 'Card number is required';
        }
      },
      validateCardExpiry() {
        if (!this.cardExpiry) {
          this.errCardExpiry = 'Expiration is required';
        }
      },
      validateCardCVC() {
        if (!this.cardCvc) {
          this.errCardCvc = 'CVC is required';
        }
      }
    }
  }
</script>
<style lang='scss' scoped>
  ::v-deep .modal-login {
    max-width: 360px !important;
    
    @media (max-width: 576px) {
      max-width: 320px !important;
      margin-left: auto;
      margin-right: auto;
    }

    .modal-body {
      .card-icon-wrapper {
        padding: 10px 0 10px 18px;
        display: inherit;
        border: 1px solid #9A9A9A;
        border-right: 0;
        border-top-left-radius: 0.25rem;
        border-bottom-left-radius: 0.25rem;
      }

      .input-group-focus {
        .card-icon-wrapper {
          border-color: #f96332;
        }
      }

      .has-danger {
        .card-icon-wrapper {
          border-color: #ffcfcf;
        }
        .form-control {
          border-left: 1px #ffcfcf solid;

          &[placeholder="#### #### #### ####"] {
            border-left: none;
          }
        }
      }
    }

    .modal-footer {
      display: block;
    }
  }
</style>
